export default [
    {
        path: 'calendario',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'CalendarioController' }
    },
    {
        path: 'calendario/add',
        component: require('./Add').default,
        meta: { middleware: 'auth', controller: 'CalendarioController' },
    },
    {
        path: 'calendario/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'CalendarioController' },
    },

];


